function hotTopBgImgVisibility() {
  if ($('.center--home-under-promo').length) {
    var wS = $(window).scrollTop();
    var item = $('.center--home-under-promo');
    var itemOffset = item.offset().top;
    if (wS > itemOffset) {
      $('.promo__home-background-wrap').addClass('hidden');
    } else {
      $('.promo__home-background-wrap').removeClass('hidden');
    }
  }
}
$(document).ready(function () {
  if ($('.touchevents').length) {
    hotTopBgImgVisibility();
  }
 
});
$(window).on('scroll resize orientationchange', function () {
  if ($('.touchevents').length) {
    hotTopBgImgVisibility();
  }
});
